import { render } from "./PortalPopup.vue?vue&type=template&id=436f32a2"
import script from "./PortalPopup.vue?vue&type=script&lang=js"
export * from "./PortalPopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PortalPopup.vue?vue&type=style&index=0&id=436f32a2&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__